import MapboxDraw from "@mapbox/mapbox-gl-draw";

export const mapboxDrawControls: Partial<MapboxDraw.MapboxDrawControls> = {
  line_string: true,
  polygon: true,
  point: true,
  trash: true,
  combine_features: false,
  uncombine_features: false,
};

export const TOP_LEFT = "top-left";

export const mapCenter = { lng: -73.668761, lat: 45.150739 };

export const mapOptions = {
  container: "mapId",
  accessToken: process.env.VUE_APP_MAPBOX_ACCESS_TOKEN,
  style: "mapbox://styles/mapbox/satellite-v9",
  center: mapCenter,
  zoom: 16,
  attributionControl: false,
};
